import { useParams, useNavigate } from 'react-router-dom'

import { AssignmentForm } from '@containers/Forms/Assignment'
import { TAssignmentForm } from '@containers/Forms/Assignment/schema'
import { useAlerts } from '@hooks/alerts'

import { useAddTaskContext } from '../AddTaskContext'

export function EditDummyAssignmentFormScreen() {
  const { showDeleteAlert, showDismissAlert } = useAlerts()
  const navigate = useNavigate()
  const { dummyAssignmentId, duration } = useParams<{
    dummyAssignmentId: string
    duration: string
  }>()

  const { assignmentsData, setAssignmentsData } = useAddTaskContext()

  const assignment = assignmentsData.find(
    (a) => a.dummyAssignmentId === dummyAssignmentId,
  )

  const initialTask = {
    code: '',
    startTime: new Date(),
    duration: Number(duration),
  }

  function handleEditDummyAssignment(assignment: TAssignmentForm) {
    const editedAssignments = assignmentsData.map((a) =>
      a.dummyAssignmentId === dummyAssignmentId ? { ...a, ...assignment } : a,
    )

    setAssignmentsData(editedAssignments)
    navigate(-1)
  }

  function deleteDummyAssignment() {
    const filteredAssignments = assignmentsData.filter(
      (assignment) => assignment.dummyAssignmentId !== dummyAssignmentId,
    )

    setAssignmentsData(filteredAssignments)
    navigate(-1)
  }

  function handleShowAlertOnAssignmentDelete() {
    showDeleteAlert('Assignment', deleteDummyAssignment)
  }

  function handleShowAlertOnAssignmentDismiss() {
    showDismissAlert(() => navigate(-1))
  }

  return (
    <AssignmentForm
      onSave={handleEditDummyAssignment}
      onDelete={handleShowAlertOnAssignmentDelete}
      onClose={handleShowAlertOnAssignmentDismiss}
      task={initialTask}
      assignment={assignment}
      title="Edit Resource"
    />
  )
}
